import { render, staticRenderFns } from "./ModalRemoveAnimal.vue?vue&type=template&id=e47b6874&scoped=true&"
import script from "./ModalRemoveAnimal.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveAnimal.vue?vue&type=script&lang=js&"
import style0 from "./ModalRemoveAnimal.vue?vue&type=style&index=0&id=e47b6874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47b6874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VTextarea})
